import { Text } from '@/shared/ui';
import { TagList } from '@/shared/ui/tag-list/TagList';
import type { AssessmentTableRowData } from '../helpers/formatted-assessment-table-data';

type Props = {
  row: AssessmentTableRowData;
  onClick?: () => void;
};

export const AssessmentNameCellWithTags = ({ row, onClick }: Props) => {
  const assignedTags = row.accumulation?.accumulation_tags ?? [];

  return (
    <div className="flex flex-col gap-1">
      {onClick ? (
        <Text variant="link" onClick={onClick}>
          {row.name}
        </Text>
      ) : (
        <Text>{row.name}</Text>
      )}
      {assignedTags.length > 0 && <TagList tags={assignedTags} maxDisplay={2} size="small" />}
    </div>
  );
};
